<div class="flex flex-col w-full h-full">
    <label
        class="text-base font-medium"
        *ngIf="config?.label !== null"
        [for]="config?.id"
        >{{ config?.label }}</label
    >
    <ng-template [ngIf]="!control" [ngIfElse]="formReactiveField">
        <div class="flex items-center gap-2">
            <div class="h-full w-full rounded-lg relative">
                <input
                    [placeholder]="placeholder"
                    class="w-full h-full rounded-lg"
                    [ngClass]="{
                        'bg-gray-50 text-gray-500': disabled,
                        'pr-10': hasHideIcon
                    }"
                    [name]="config?.name ?? ''"
                    [id]="config?.id ?? ''"
                    [type]="hideChars ? 'password' : config?.type ?? 'text'"
                    [(ngModel)]="value"
                    [disabled]="disabled"
                    (ngModelChange)="onChangeListener($event)"
                />
                <ng-template [ngIf]="hasHideIcon">
                    <ng-template [ngIf]="hideChars" [ngIfElse]="showCharsIcon">
                        <span title="Show input text">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6 absolute right-2 top-1/2 -translate-y-1/2 hover:cursor-pointer hover:text-teal-400"
                                (click)="showCharsListener()"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                                />
                            </svg>
                        </span>
                    </ng-template>
                    <ng-template #showCharsIcon>
                        <span title="Hide input text">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6 absolute right-2 top-1/2 -translate-y-1/2 hover:cursor-pointer hover:text-teal-400"
                                (click)="hideCharsListener()"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                                />
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                            </svg>
                        </span>
                    </ng-template>
                </ng-template>
            </div>
            <ng-template [ngIf]="hasCopyIcon">
                <span class="flex items-center" title="Copy input text">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 hover:cursor-pointer hover:text-teal-400"
                        (click)="copyToClipboard()"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M16.5 8.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v8.25A2.25 2.25 0 006 16.5h2.25m8.25-8.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-7.5A2.25 2.25 0 018.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 00-2.25 2.25v6"
                        />
                    </svg>
                </span>
            </ng-template>
        </div>
    </ng-template>
    <ng-template #formReactiveField>
        <div class="flex items-center gap-2">
            <div class="h-full w-full rounded-lg relative">
                <input
                    [placeholder]="placeholder"
                    class="w-full h-full rounded-lg"
                    [ngClass]="{
                        'bg-gray-50 text-gray-500': disabled,
                        'pr-10': hasHideIcon
                    }"
                    [name]="config?.name ?? ''"
                    [id]="config?.id ?? ''"
                    [type]="hideChars ? 'password' : config?.type ?? 'text'"
                    [formControl]="control"
                />
                <ng-template [ngIf]="hasHideIcon">
                    <ng-template [ngIf]="hideChars" [ngIfElse]="showCharsIcon">
                        <span title="Show input text">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6 absolute right-2 top-1/2 -translate-y-1/2 hover:cursor-pointer hover:text-teal-400"
                                (click)="showCharsListener()"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                                />
                            </svg>
                        </span>
                    </ng-template>
                    <ng-template #showCharsIcon>
                        <span title="Hide input text">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6 absolute right-2 top-1/2 -translate-y-1/2 hover:cursor-pointer hover:text-teal-400"
                                (click)="hideCharsListener()"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                                />
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                            </svg>
                        </span>
                    </ng-template>
                </ng-template>
            </div>
            <ng-template [ngIf]="hasCopyIcon">
                <span class="flex items-center" title="Copy input text">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6 hover:cursor-pointer hover:text-teal-400"
                        (click)="copyToClipboard()"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M16.5 8.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v8.25A2.25 2.25 0 006 16.5h2.25m8.25-8.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-7.5A2.25 2.25 0 018.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 00-2.25 2.25v6"
                        />
                    </svg>
                </span>
            </ng-template>
        </div>
        <div
            *ngIf="control.invalid && (control.dirty || control.touched)"
            class="alert alert-error mt-1"
        >
            <ng-template ngFor let-error [ngForOf]="errors">
                <div *ngIf="error">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                    <span>{{ error }}</span>
                </div>
            </ng-template>
        </div>
    </ng-template>
</div>
